// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_road--solid"><path id="Union" d="M20 22.0002H13V18.0002H11V22.0002H4V2.00024H11V6.00024H13V2.00024H20V22.0002ZM11 10.0002V14.0002H13V10.0002H11Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_road--line"><path id="Union" d="M6 22H4V2H6V22ZM13 22H11V18H13V22ZM20 22H18V2H20V22ZM13 14H11V10H13V14ZM13 6H11V2H13V6Z" style="fill: currentColor"/></g></svg>`;

export const Road: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
